(ns manage.ad-variant-insights.queries
  (:require [common.queries.http :as qhttp]))

(defn adset-insights-query [{:keys [advertiser-id adset-id]}]
  #js {:queryKey #js ["adset-insights" advertiser-id adset-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/adset-insights {:advertiser-id advertiser-id
                                                                        :adset-id adset-id})))
       :enabled (and (some? advertiser-id) (some? adset-id))})

(defn ctr-per-day-query [{:keys [adset-id start-date end-date]}]
  #js {:queryKey #js ["adset-ctr-per-day" adset-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/adset-ctr-per-day
                                           {:adset-id adset-id}
                                           {:start_date start-date
                                            :end_date end-date})))
       :enabled (and (some? adset-id) (some? start-date) (some? end-date))})

(defn adset-stats [{:keys [adset-id start-date end-date]}]
  #js {:queryKey #js ["adset-insights-stats" adset-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/adset-insights-stats
                                           {:adset-id adset-id}
                                           {:start_date start-date
                                            :end_date end-date})))
       :enabled (and (some? adset-id) (some? start-date) (some? end-date))})

(defn decision-tree-paths-stats [{:keys [adset-id start-date end-date]}]
  #js {:queryKey #js ["decision-tree-paths-stats" adset-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/adset-insights-decision-tree-stats
                                           {:adset-id adset-id}
                                           {:start_date start-date
                                            :end_date end-date})))
       :enabled (and (some? adset-id) (some? start-date) (some? end-date))})

(defn ad-variant-stats [{:keys [adset-id start-date end-date]}]
  #js {:queryKey #js ["ad-variant-stats" adset-id]
       :queryFn (fn [_ctx]
                  (qhttp/get (qhttp/render :measure-api/ad-variant
                                           {}
                                           {:adset_id adset-id
                                            :start_date start-date
                                            :end_date end-date})))
       :enabled (and (some? adset-id) (some? start-date) (some? end-date))})
